module.exports = __webpack_public_path__ + "img/ecart-ecommerce.e7ae3ee1.png";